<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Patient Payments",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
     current_date: moment(new Date()).format("YYYY-MM-DD"),
      title: "Patient Payments",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Patient Payments",
          active: true,
        },
      ],
      total_amount:0,
      total_paid:0,
      total_balance:0,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "Name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "Code",
          sortable: true,
          label: "CODE",
        },
        {
          key: "Contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "amount",
          sortable: true,
          label: "TOTAL AMOUNT",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },         
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      json_fields: {
        BRANCH: "branch",
        NAME: "Name",
        PATIENT_CODE: "Code",
        PATIENT_CONTACT: "Contact",
        TOTAL_AMOUNT: "amount",
        PAID_AMOUNT: "paid",
        BALANCE: "balance",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("reports", [
      "PaymentsReport"
    ]),
   
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.PaymentsReport ? this.PaymentsReport.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PaymentsReport ? this.PaymentsReport.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPaymentsReport: "reports/fetchPayments",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
   /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // END VALIDATION
    Totals(){
      let rep_total_amount = 0;
      let rep_total_paid = 0;
      this.PaymentsReport.forEach((item) => {
        // alert(item.amount)
        rep_total_amount = rep_total_amount+parseInt(item.amount)+parseInt(item.ins_amount);
        rep_total_paid = rep_total_paid+parseInt(item.paid)+parseInt(item.ins_paid);
      });
      this.total_amount = this.thousandSeprator(rep_total_amount);
      this.total_paid = this.thousandSeprator(rep_total_paid);
      this.total_balance = this.thousandSeprator(rep_total_amount - rep_total_paid);
    }
  },
  created() {
    this.FetchPaymentsReport();
    this.Totals();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
<div class="row">
   <div class="col-12">
        <div class="card">
          <div class="card-body">
          <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
              <download-excel
                  class="btn btn-primary mb-1"
                  :data="PaymentsReport"
                  :fields="json_fields"
                  :worksheet="'PAYMENTS REPORT FOR' + current_date"
                  type="csv"
                  :name="'Payments_report' + current_date + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
            </div>         
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="PaymentsReport"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                >services
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                    <div class="text-warning">
                      <router-link :to="`/reports/patientpayment_details/${data.item.id}`">View Details</router-link>                  
                  </div>
                </template>
                <template #cell(amount)="data">
                  {{thousandSeprator(parseInt(data.item.ins_amount) + parseInt(data.item.amount))}}                
                </template>
                <template #cell(paid)="data">
                  {{thousandSeprator(parseInt(data.item.ins_paid) + parseInt(data.item.paid))}}                
                </template>
                <template #cell(balance)="data">
                  {{thousandSeprator((parseInt(data.item.ins_amount) + parseInt(data.item.amount)) - (parseInt(data.item.ins_paid) + parseInt(data.item.paid)))}}                
                </template>
                <!-- <template #foot(amount)=""
                  >Total Amount
                  <span class="text-danger"> {{ total_amount }}</span>
                </template>
                <template #foot(paid)=""
                  >Total Paid
                  <span class="text-danger"> {{ total_paid }}</span>
                </template>
                <template #foot(balance)=""
                  >Total Balance
                  <span class="text-danger"> {{ total_balance }}</span>
                </template> -->
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!PaymentsReport" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
               </div>
            </div>
          </div>
          </div>
        </div>
  </Layout>
</template>
